module.exports = __webpack_public_path__ + "img/prod_golden_item.3698b730.png";